import { initLocalization } from '@adsk/alloy-react-localization';

const getLocale = async (language: string) => {
  // eslint-disable-next-line no-unsanitized/method
  return import(`./${language}.json`);
};

const { useTranslation } = initLocalization({
  getLocale,
});

export { useTranslation };
